import { IAgentesBackendRequestDto, IAgentesBackendResponse } from '../interfaces/IAgentesBackend';

export const agentsMapper = {
  toDto: (values: any): IAgentesBackendRequestDto => {
    return {
      name: values.name,
      description: values.description,
      service_id: values.service_id.value,
      systemPrompt: values.systemPrompt,
      temperature: values.temperature !== '' ? Number(values.temperature) : undefined,
      topP: values.topP !== '' ? Number(values.topP) : undefined,
      maxTokens: values.maxTokens !== '' ? Number(values.maxTokens) : undefined,
      enableTools: values.enableTools,
      enableMemory: values.enableMemory,
      enableReasoning: values.enableReasoning,
      enableFunctionCall: values.enableFunctionCall,
      enableSearch: values.enableSearch,
      enableCodeExecution: values.enableCodeExecution,
      executionMode: values.executionMode?.value || values.executionMode,
    };
  },
  toDomain: (item: IAgentesBackendResponse): any => {
    return {
      id: item.id,
      name: item.name,
      description: item.description,
      serviceId: item.service?.id || item.service_id,
      systemPrompt: item.systemPrompt,
      temperature: item.temperature,
      topP: item.topP,
      maxTokens: item.maxTokens,
      enableTools: item.enableTools,
      enableMemory: item.enableMemory,
      enableReasoning: item.enableReasoning,
      enableFunctionCall: item.enableFunctionCall,
      enableSearch: item.enableSearch,
      enableCodeExecution: item.enableCodeExecution,
      executionMode: item.executionMode,
    };
  },
};
